import tnpLogo from "../../assets/images/tnp-logo-neon.png";
import "./TnpOrganizerLogo.css";

type TnpOrganizerLogoProps = {
  className?: string;
  size?: "compact" | "picker" | "card" | "title";
};

export function isTnpOrganizer(value?: string | null) {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

  return [
    "tnp",
    "organizacao tnp",
    "tnp organizacao",
    "organization tnp",
    "tnp organization",
    "organizacion tnp",
    "tnp organizacion",
    "todos no padel",
  ].includes(normalized);
}

export default function TnpOrganizerLogo({
  className = "",
  size = "compact",
}: TnpOrganizerLogoProps) {
  return (
    <img
      className={`tnp-organizer-logo tnp-organizer-logo--${size}${
        className ? ` ${className}` : ""
      }`}
      src={tnpLogo}
      alt="TNP - Todos no Padel"
    />
  );
}
